import { render, staticRenderFns } from "./JayuLogo.vue?vue&type=template&id=221d1c16"
import script from "./JayuLogo.vue?vue&type=script&lang=js"
export * from "./JayuLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports